import {
  AuditLog,
  ConnectorAuditLog,
  LogType,
  ScanAuditLog,
  MembersAuditLog,
  LoginOptionsAuditLog,
  AuthenticationAuditLog,
} from '@oxappsec/ox-unified-audit-logger';
import { FC } from 'react';
import ConnectorsAdditionalInfo from './ConnectorsAdditionalInfo';
import AuthenticationAdditionalInfo from './AuthenticationAdditionalInfo';
import LoginOptionsAdditionalInfo from './LoginOptionsAdditionalInfo';
import MembersAdditionalInfo from './MembersAdditionalInfo';
import ScanAdditionalInfo from './ScanAdditionalInfo';

const AdditionalInfoSwitcher: FC<
  React.PropsWithChildren<AdditionalInfoSwitcherProps>
> = ({ auditLog }) => {
  const { logType } = auditLog;

  switch (logType) {
    case LogType.Connectors:
      return (
        <ConnectorsAdditionalInfo auditLog={auditLog as ConnectorAuditLog} />
      );
    case LogType.Scan:
      return <ScanAdditionalInfo auditLog={auditLog as ScanAuditLog} />;
    case LogType.LoginOptions:
      return (
        <LoginOptionsAdditionalInfo
          auditLog={auditLog as LoginOptionsAuditLog}
        />
      );
    case LogType.Members:
      return <MembersAdditionalInfo auditLog={auditLog as MembersAuditLog} />;
    case LogType.Authentication:
      return (
        <AuthenticationAdditionalInfo
          auditLog={auditLog as AuthenticationAuditLog}
        />
      );
    default:
      return null;
  }
};

export interface AdditionalInfoSwitcherProps {
  auditLog: AuditLog;
}

export default AdditionalInfoSwitcher;
